var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"export-button"},[_c('r-button',{attrs:{"mini":_vm.mini,"type":"primary"},on:{"click":function($event){_vm.visible = true}}},[_vm._v(" Экспортировать ")]),_c('export-modal',{attrs:{"visible":_vm.visible,"uri":_vm.uri,"name":_vm.name,"book-export":_vm.bookExport,"hard-uri":_vm.hardUri},on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }